import apiClient from "api/client/axios.client";
import type { LanguageDto } from "types/language.types";

interface ApiResponse<T> {
  statusCode: number;
  message: string | null;
  data: T;
  errors: string[] | null;
}

export const languageService = {
  getAll: async (): Promise<LanguageDto[]> => {
    const res = await apiClient.get<ApiResponse<LanguageDto[]>>(
      "/Setting/v1/Language"
    );
    return res.data.data;
  },
};
